import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as JSZip from 'jszip';
import { TranslateService } from 'ng2-translate';
import { Observable, Subscription } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { RegionService } from '../../admin/user-management/region.service';
import { UserBlob } from '../../shared';
import { Principal } from '../../shared/auth/principal.service';
import { Document } from '../../shared/download/document.model';
import { DownloadService } from '../../shared/download/download.service';
import { ZipSaisine } from '../../shared/download/zip.model';
import { CustomDatePipe } from '../../shared/utils/date.pipe';
import { UtilsService } from '../../shared/utils/utils.service';
import { CampaignService } from '../campaign/campaign.service';
import { MasterService } from '../master/master.service';
import { SaisineCommentType } from '../saisine-comment/saisine-comment.model';
import { PropertiesService } from './properties.service';
import { Saisine, SaisineStatus } from './saisine.model';
import { SaisineService } from './saisine.service';

@Component({
    selector: 'jhi-saisine-detail',
    templateUrl: './saisine-detail.component.html'
})
export class SaisineDetailComponent implements OnInit, OnDestroy {

    saisineId: number;
    saisine: Saisine;
    saisineStatus = SaisineStatus;

    patternZipName: RegExp;
    patternReplacement: string;

    currentAccount: any;
    isSaisineFromMyRegion = false;
    isSaisineFromMyAcademy = false;
    zipDownloading = false;
    errorZip = false;

    zipSaisine: ZipSaisine;
    commentTypes: any = SaisineCommentType;

    visibleFormHandicapDisability: boolean;

    nbDemandesHorsRegion: number;

    documents: UserBlob[];

    private subscription: Subscription = new Subscription();

    constructor(
        private saisineService: SaisineService,
        private route: ActivatedRoute,
        private datePipe: CustomDatePipe,
        public principal: Principal,
        public masterService: MasterService,
        public downloadService: DownloadService,
        private utilsService: UtilsService,
        private translateService: TranslateService,
        public campaignService: CampaignService,
        private regionService: RegionService,
        private propertiesService: PropertiesService
    ) { }

    ngOnInit() {
        this.subscription.add(this.route.params.subscribe(params => {
            this.saisineId = params['id'];
            this.load(this.saisineId);
        }));

        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.visibleFormHandicapDisability = ('true' === this.propertiesService.properties.visibleFormHandicapDisability);
    }

    load(id) {
        this.subscription.add(Observable.combineLatest(this.saisineService.find(id), this.regionService.getRegions({ 'campaign': this.campaignService.getDisplayedCampaign() })).subscribe(([saisine, regions]) => {
            this.isSaisineFromMyRegion = this.principal.getAcademicRegionLabel() === saisine.licenceAcademicRegionLabel;
            this.isSaisineFromMyAcademy = this.principal.getAcademyLabel() === saisine.licenceAcademyLabel;

            let saisineRegion = regions.find(r => r.academicRegionLabel === saisine.licenceAcademicRegionLabel);
            this.nbDemandesHorsRegion = saisineRegion ? saisineRegion.nbDemandesHorsRegion : null;

            this.saisine = saisine;

            this.subscription.add(this.saisineService.getSaisineDocumentsInfo(id).subscribe(documents => this.documents = documents));
        }));
    }

    previousState() {
        window.history.back();
    }

    initZip() {
        this.zipDownloading = true;
        let regexp = '\s?([' + this.propertiesService.properties.patternExclusionString + '])\s?';
        this.patternZipName = new RegExp(regexp, 'g');
        this.patternReplacement = this.propertiesService.properties.patternReplacement;

        let studentName = this.saisine.lastName + this.saisine.firstName;
        studentName.replace(this.patternZipName, this.patternReplacement);
        studentName.replace(new RegExp(' ', 'g'), '');
        let nameZip = 'Saisine-' + this.saisine.reference + '-' + studentName + '-' + this.datePipe.transform(new Date(), 'yyyy-MM-dd') + '.zip';
        let docs = [];
        this.zipSaisine = new ZipSaisine(nameZip);
        this.zipSaisine.zip = JSZip();
        this.zipSaisine.documents = docs;

        this.prepareZip();
    }

    prepareZip() {
        // gestion de la liste des docs
        if (!isNullOrUndefined(this.saisine.licenceDocumentUserBlobFilename)) {
            this.zipSaisine.documents.push(new Document(this.replaceFileName(this.saisine.licenceDocumentUserBlobFilename), this.saisine.licenceDocumentUserBlobId, 'DNL-'));
        }
        this.saisine.reportCards.forEach((rc, index) => {
            if (!isNullOrUndefined(rc.blobFilename)) {
                this.zipSaisine.documents.push(new Document(this.replaceFileName(rc.blobFilename), rc.blobId, 'RN-' + (Number(index) + 1) + '-'));
            }
        });
        if (!isNullOrUndefined(this.saisine.cvDocumentUserBlobFilename)) {
            this.zipSaisine.documents.push(new Document(this.replaceFileName(this.saisine.cvDocumentUserBlobFilename), this.saisine.cvDocumentUserBlobId, 'CV-'));
        }
        if (!isNullOrUndefined(this.saisine.motivationLetterUserBlobFilename)) {
            this.zipSaisine.documents.push(new Document(this.replaceFileName(this.saisine.motivationLetterUserBlobFilename), this.saisine.motivationLetterDocumentUserBlobId, 'LM-'));
        }
        if (!this.principal.isSchoolProfile()) {
            this.saisine.refusedMasters.forEach((rm, index) => {
                if (!isNullOrUndefined(rm.refusalDocumentUserBlobFilename)) {
                    this.zipSaisine.documents.push(new Document(this.replaceFileName(rm.refusalDocumentUserBlobFilename), rm.refusalDocumentUserBlobId, 'RAM-' + (Number(index) + 1) + '-'));
                }
            });
        }
        this.saisine.academicDocuments.forEach((ad, index) => {
            if (!isNullOrUndefined(ad.academicDocumentUserBlobFilename)) {
                this.zipSaisine.documents.push(new Document(this.replaceFileName(ad.academicDocumentUserBlobFilename), ad.academicDocumentUserBlobId, 'DC-' + (Number(index) + 1) + '-'));
            }
        });

        this.zipSaisine.zip.file('Saisine.txt', this.setSaisineText());

        return this.downloadZip();
    }

    setSaisineText(): string {
        let numberZipTextElement = 1;
        let text = '';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.titre') + this.saisine.reference;
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.statut') + this.translateService.instant('tmmsaisineApp.licenseList.' + this.saisine.status);
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateDepot');
        text += this.saisine.firstSubmitDate ? this.datePipe.transform(this.saisine.firstSubmitDate) : '';
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateDerniereTransmission');
        text += this.saisine.submitDate ? this.datePipe.transform(this.saisine.submitDate) : '';
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateValidationDossierRectorat');
        text += this.saisine.checkingDate ? this.datePipe.transform(this.saisine.checkingDate) : '';
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateEnvoiTroisPropos');
        text += this.saisine.treatedDate ? this.datePipe.transform(this.saisine.treatedDate) : '';
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateAbandon');
        text += this.saisine.abandonedDate ? this.datePipe.transform(this.saisine.abandonedDate) : '';
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateClotureDossier');
        text += this.saisine.closureDate ? this.datePipe.transform(this.saisine.closureDate) : '';
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateRejetDefinitif');
        text += this.saisine.canceledDate ? this.datePipe.transform(this.saisine.canceledDate) : '';
        text += '\r\n';

        text += '\r\n';
        text += '\r\n';

        text += this.exportPersonalInformations();


        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.licence');
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.mention');
        text += this.saisine.licenceTitle;
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.etablissement');
        text += this.saisine.licenceSchoolLabel;
        text += '\r\n';
        if (!this.principal.isSchoolProfile()) {
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.anneeObtention');
            text += this.saisine.licenceDate;
            text += '\r\n';
        }

        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dnl');
        text += this.saisine.licenceDocumentUserBlobFilename;
        text += '\r\n';

        text += '\r\n';
        text += '\r\n';

        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.relevesNotes');
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.releveNote');
        this.saisine.reportCards.forEach(rc => {
            text += rc.blobFilename + ' ';
        });
        text += '\r\n';

        text += '\r\n';
        text += '\r\n';

        if (!this.principal.isSchoolProfile()) {
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.candidatures');
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.nombreCandidatures');
            text += this.saisine.numberRefusedMaster;
            text += '\r\n';
            this.saisine.refusedMasters.forEach(rm => {
                text += this.translateService.instant('tmmsaisineApp.saisine.zipText.candidatureRefusee');
                text += numberZipTextElement;
                numberZipTextElement++;
                text += '\r\n';
                text += this.translateService.instant('tmmsaisineApp.saisine.zipText.referenceMaster');
                text += this.masterService.getMasterTitle(rm.master);
                text += '\r\n';
                text += this.translateService.instant('tmmsaisineApp.saisine.zipText.justificatifRefus');
                text += rm.refusalDocumentUserBlobFilename;
                text += '\r\n';
            });

            text += '\r\n';
            text += '\r\n';
        }

        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.documents');
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.cv');
        text += this.saisine.cvDocumentUserBlobFilename;
        text += '\r\n';
        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.ldm');
        text += this.saisine.motivationLetterUserBlobFilename;
        text += '\r\n';

        text += '\r\n';
        text += '\r\n';

        text += this.translateService.instant('tmmsaisineApp.saisine.zipText.docComplementaire');
        text += '\r\n';
        numberZipTextElement = 1;
        this.saisine.academicDocuments.forEach(acaDoc => {
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.docAcademiqueNum');
            text += numberZipTextElement;
            numberZipTextElement++;
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.descriptionDocument');
            text += acaDoc.description;
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.nomDocument');
            text += acaDoc.academicDocumentUserBlobFilename;
            text += '\r\n';
        });

        text += '\r\n';
        text += '\r\n';

        return text;
    }

    exportPersonalInformations() {
        let text = '';
        if (!this.principal.isSchoolProfile()) {
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.infoPerso');
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.nomPatronique');
            text += this.saisine.lastName;
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.prenom');
            text += this.saisine.firstName;
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.email');
            text += this.saisine.student.email;
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.dateNaissance');
            text += this.saisine.birthDate ? this.datePipe.transform(this.saisine.birthDate) : '';
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.lieuNaissance') + this.saisine.birthPlace;
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.sexe');
            text += this.saisine.sex ? this.saisine.sex : '';
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.inebea');
            text += this.saisine.inebea ? this.saisine.inebea : '';
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.nomUsage');
            text += this.saisine.useName ? this.saisine.useName : '';
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.prenomDeux');
            text += this.saisine.firstName2 ? this.saisine.firstName2 : '';
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.prenomTrois');
            text += this.saisine.firstName3 ? this.saisine.firstName3 : '';
            text += '\r\n';

            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.adresseTitre');
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.adresse');
            text += this.saisine.streetAddress ? this.saisine.streetAddress : '';
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.codePostal');
            text += this.saisine.postalCode ? this.saisine.postalCode : '';
            text += '\r\n';
            text += this.translateService.instant('tmmsaisineApp.saisine.zipText.ville');
            text += this.saisine.city ? this.saisine.city : '';
            text += '\r\n';

            text += '\r\n';
            text += '\r\n';
        }
        return text;
    }

    replaceFileName(docName) {
        return docName.replace(this.patternZipName, this.patternReplacement);
    }

    downloadZip() {
        this.downloadService.downloadBlob(this.zipSaisine).then(() => {
            this.errorZip = false;
            this.zipDownloading = false;
            this.zipSaisine = undefined;
        }).catch(err => {
            // affiche un message d'erreur et go top
            this.utilsService.scrollToTop();
            this.errorZip = true;
            this.zipDownloading = false;
            this.zipSaisine = undefined;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    isDocumentNew(id: string): boolean {
        if (!this.saisine.rejections || this.saisine.rejections.length === 0) { return false; }

        let dateLastRejection = this.saisine.rejections.map(_ => _.date).reduce((a, b) => a > b ? a : b);
        return id && this.saisine && this.documents
            && this.saisine.status === SaisineStatus.TO_CHECK
            && this.documents.find(d => d.id === id).creationDate > dateLastRejection;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-detail.component.ts